export const API_URL = 'https://bouquetin.muraro.dev/api/';
